<template lang="">
  <div class="col-xs-12">
    <header class="sec-heading dark">
      <h2 class="text-themed">{{ title }}</h2>
    </header>
  </div>
  <div class="row" v-if="dates.length">
    <div class="col-md-6">
      <div class="form-group">
        <label for="date-form">{{ translation.date }}</label>
        <select
          class="form-control"
          v-model="selected"
          required
          id="date-form"
          name="date"
          @change="updateTimes"
        >
          <option value="" selected disabled>{{ pleasechoose }}</option>
          <option
            :value="date.date"
            v-bind:key="index"
            v-for="(date, index) in dates"
          >
            {{ formatDate(date.date) }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label for="time-form">{{ translation.time }}</label>
        <select required class="form-control" name="time" id="time-form">
          <option value="" selected disabled>{{ pleasechoose }}</option>
          <option
            :value="time"
            v-bind:key="index"
            v-for="(time, index) in timesArray.times"
          >
            {{ time }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label for="person-form">{{ translation.persons }}</label>
        <select
          class="form-control"
          name="persons"
          id="person-form"
          v-model="selectedPersons"
        >
          <option disabled>{{ pleasechoose }}</option>
          <option
            v-bind:key="index"
            required
            v-for="(person, index) in persons"
            :value="person"
          >
            {{ person }} {{ translation.person }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <slot name="verkostung" v-if="dates.length"></slot>

  <slot name="vegan" v-if="dates.length" :max-persons="selectedPersons"></slot>

  <div class="row" v-if="dates.length">
    <div class="clearfix"></div>
    <div class="col-md-6">
      <button type="submit" class="btn btn-primary mt-3">
        {{ button }}
      </button>
    </div>
  </div>
  <div class="text-center" v-if="!dates.length">
    {{ nodates }}
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  verkostung: {
    type: Boolean,
    required: true,
  },
  button: {
    type: String,
    required: true,
  },
  language: {
    type: [String, Number],
    required: true,
  },
  min: {
    type: Number,
    required: true,
  },
  max: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  dates: {
    type: Array,
    required: true,
  },
});

const selected = ref("");
const selectedPersons = ref(props.min);

onMounted(() => {
  selected.value = props.dates[0]?.date;
});

const translationsDE = {
  date: "Datum",
  time: "Uhrzeit",
  persons: "Personen",
  person: "Person/en",
};

const translationEN = {
  date: "Date",
  time: "Time",
  persons: "Persons",
  person: "Person/s",
};

const isGerman = computed(() => {
  return Number(props.language) === 1;
});

const pleasechoose = computed(() => {
  return isGerman.value ? "Bitte wählen" : "Please choose";
});

const translation = computed(() => {
  return isGerman.value ? translationsDE : translationEN;
});

const nodates = computed(() => {
  return isGerman.value ? "Keine Termine verfügbar" : "No dates available";
});


const readyToSubmit = computed(() => {
  return selected.value !== "";
});

const formatDate = (date) => {
  let newDate = new Date(date);
  let options = {
    weekday: "short",
    day: "2-digit",
    month: "long",
    year: "numeric",
  };
  let formatter = isGerman.value
    ? new Intl.DateTimeFormat("de-DE", options)
    : new Intl.DateTimeFormat("en-GB", options);

  return formatter.format(newDate);
};

const persons = computed(() => {
  let count = [];
  for (let index = props.min; index <= props.max; index++) {
    count.push(index);
  }
  return count;
});

const timesArray = computed(() => {
  let times = props.dates.find((date) => {
    return date.date === selected.value;
  });

  if (!times) {
    return {
      times: [],
    };
  }

  return times;
});
</script>
